
<m-title>
    <naming-convention-label [type]="'Group'" [singular]="false"></naming-convention-label>
</m-title>
<div class="filter-container">
    <p-card class="filter-card">
        <div class="grid row">
            <div class="col-11 col-11-padding">
                <filter #filter class="groups-filter" [settings]="filterSettings"></filter>
            </div>
            <div class="col-1 filter-add-button" *ngIf="hasWritePermissions()">
                <button
                    pButton
                    class="m-button-primary ml-2"
                    label="Add {{namingConventionService.groupSingular}}"
                    (click)="addSquad($event)">
                </button>
            </div>
        </div>
    </p-card>
</div>

<div class="card main-container">
    <grid [tableSettings]="tableSettings" [gridSettings]="gridSettings" [filter]="filter"></grid>
</div>

<p-dialog
        [(visible)]="editingSquadInProcess"
        appendTo="body"
        [modal]="true"
        [header]="isCreate ? 'Create '+ namingConventionService.groupSingular : 'Edit '+ namingConventionService.groupSingular"
        [style]="{'max-width': '700px', width: '100%'}">

        <ng-container *miproLoading="loadingPatients">
            <ng-container *ngTemplateOutlet="templateRefVar"></ng-container>
        </ng-container>
        
    <ng-template #templateRefVar>
        <div class="p-g">
            <div class="p-g-12">
                <form [formGroup]="squadForm" (ngSubmit)="saveSquad()">
                    <div class="inputs-group">
                        <div class="inputs-group-row">
                            <label class="inputs-group-row-name asterisk-mark">Name:</label>
                            <div class="inputs-group-row-value">
                                <input *ngIf="hasWritePermissions(); else readonly_name" type="text" pInputText formControlName="name" />
                                <ng-template #readonly_name>
                                    <input type="text" pInputText formControlName="name" readonly />
                                </ng-template>
                            </div>
                        </div>
                        <div class="inputs-group-row">
                            <label class="inputs-group-row-name">Notes:</label>
                            <div class="inputs-group-row-value">
                                <textarea *ngIf="hasWritePermissions(); else readonly_notes" pInputTextarea formControlName="notes"></textarea>
                                <ng-template #readonly_notes>
                                    <textarea pInputTextarea formControlName="notes" readonly></textarea>
                                </ng-template>
                            </div>
                        </div>

                        <p-panel class="inputs-group-row">
                            <ng-template pTemplate="header">
                                <div class="inputs-sub-group-name">
                                    <span>Assign <naming-convention-label [singular]="false" [capitalize]="true"></naming-convention-label> to <naming-convention-label [singular]="true" [type]="'Group'"></naming-convention-label></span>
                                </div>
                            </ng-template>

                            <div class="inputs-group-row-value">
                                <p-pickList 
                                    [disabled]="isArchived" 
                                    [source]="unassignedPatients" 
                                    [target]="assignedPatients" 
                                    filterBy="firstName" 
                                    sourceFilterPlaceholder="Search by First Name" 
                                    targetFilterPlaceholder="Search by First Name">

                                    <ng-template pTemplate="sourceHeader">
                                        <span>Unassigned <naming-convention-label [singular]="false" [capitalize]="false"></naming-convention-label></span>
                                    </ng-template>

                                    <ng-template pTemplate="targetHeader">
                                        <span>Assigned <naming-convention-label [singular]="false" [capitalize]="false"></naming-convention-label></span>
                                    </ng-template>

                                    <ng-template let-player pTemplate="item">
                                        <div>{{player.firstName}} {{player.lastName}}</div>
                                    </ng-template>
                                </p-pickList>
                            </div>
                        </p-panel>
                    </div>
                    <div class="inputs-group-row">
                        <form-buttons [disabled]="squadForm.invalid" [saving]="savingSquad" [config]="squadFormButtonsConfig">
                        </form-buttons>
                    </div>
                </form>
            </div>
        </div>
    </ng-template>
</p-dialog>